import Ajax from '../common/ajax'
import ApiBase from './api-base'
import Tool from '../common/tool'

export default {
  ...ApiBase,
  model: 'category',
  changeSort (categoryId, targetId, type = 'pre' || 'next') {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/changeSort`, { categoryId, targetId, type })
  },
  async getTreeData () {
    let treeData = await Ajax.get(`/api/gradeMaster/v1/${this.model}/getCategoryTree`)
    Tool.walkTree(treeData, (node) => {
      if (Tool.isNull(node.children)) {
        delete node.children
      }
    })
    return treeData
  },
  async getGradeTreeData (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/list`, queryParam)
  }
}
